import { render } from "./DockWindow.vue?vue&type=template&id=30dd8aff"
import script from "./DockWindow.vue?vue&type=script&lang=js"
export * from "./DockWindow.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/DockWindow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30dd8aff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30dd8aff', __exports__)) {
    api.reload('30dd8aff', __exports__)
  }
  
  module.hot.accept("./DockWindow.vue?vue&type=template&id=30dd8aff", () => {
    api.rerender('30dd8aff', render)
  })

}


export default __exports__